import React, { useContext } from 'react'
import TicketChatPanel from './TicketChatPanel'
import TicketDetailsPanel from './TicketDetailsPanel'
import { AppContext } from 'AppContext'

export default function TicketChat({ ticket, refetch }) {
  const [chatAttachments, setChatAttachments] = React.useState([])
  const {
    state: {
      isAdmin,
    },
  } = useContext(AppContext)
  return (
    <div
      style={{
        display: 'flex',
        gap: 24,
        height: isAdmin ? "88vh" : "76vh",
        alignItems: 'stretch',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          flex: 2,
          minWidth: 0,
          // height: '80vh', // Match parent height
          overflowY: 'auto', // Allow internal scrolling
        }}
      >
        <TicketChatPanel
          ticket={{ ...ticket, attachments: chatAttachments }}
          setChatAttachments={setChatAttachments}
        />
      </div>
      <div
        style={{
          flex: 1,
          minWidth: 340,
          height: '100%', // Match parent height
          // overflowY: 'auto', // Allow internal scrolling
          position: 'relative', // Ensure it can scroll independently
        }}
      >
        <TicketDetailsPanel
          ticket={{ ...ticket, attachments: chatAttachments }}
          refetch={refetch}
        />
      </div>
    </div>
  )
}
